export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[768px] mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">联系我们</h2>
        <p className="text-sm text-foreground-500 mb-10">有影视推荐、合作意向或意见建议？欢迎通过以下方式联系我们</p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
            <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-50 flex items-center justify-center">
              <i className="ri-mail-line text-xl text-primary-500"></i>
            </div>
            <h3 className="text-sm font-heading text-foreground-800 mb-1">内容投稿</h3>
            <p className="text-xs text-foreground-500">content@taozivideo.cn</p>
          </div>
          <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
            <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-50 flex items-center justify-center">
              <i className="ri-briefcase-line text-xl text-accent-500"></i>
            </div>
            <h3 className="text-sm font-heading text-foreground-800 mb-1">商务合作</h3>
            <p className="text-xs text-foreground-500">biz@taozivideo.cn</p>
          </div>
          <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
            <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-50 flex items-center justify-center">
              <i className="ri-question-answer-line text-xl text-secondary-500"></i>
            </div>
            <h3 className="text-sm font-heading text-foreground-800 mb-1">意见反馈</h3>
            <p className="text-xs text-foreground-500">feedback@taozivideo.cn</p>
          </div>
        </div>
      </div>
    </section>
  );
}